import React from 'react';
import { FolderInput, Brain, Users, Calendar } from 'lucide-react';

const STEPS = [
  {
    icon: FolderInput,
    title: 'Point at the pile',
    body:
      'Drop a folder of e-receipts, downloaded 1099s, brokerage statements, and emailed invoices into Sortio. It also watches your Downloads folder so new arrivals get processed automatically.',
  },
  {
    icon: Brain,
    title: 'Read content, not filenames',
    body:
      'Sortio reads the text inside each PDF and extracts vendor, date, amount, document type (receipt, invoice, 1099-NEC, K-1, W-2, bank statement), and the client or entity name. statement(3).pdf becomes 2026-03-14_Vendor_$142.83.pdf with the right metadata attached. Image-only scans need a quick OCR pass (OCRmyPDF) first.',
  },
  {
    icon: Users,
    title: 'Route by client and tax year',
    body:
      'Each file lands in the matching client folder (Smith / 2026 / 1099s for example). Sortio recognizes business entities, sole proprietors, and 1040 individuals as separate roots and routes accordingly. You preview every assignment before files move.',
  },
  {
    icon: Calendar,
    title: 'Lock the year, archive cleanly',
    body:
      'At year end the Rule Builder packs each client folder into a read-only archive named with the filing date. Working folders empty out for the new year, the audit log captures every move, and a partner can hand off a closed client folder to storage without manual review.',
  },
];

const Workflow = () => {
  return (
    <section id="workflow" className="my-20">
      <div className="text-center mb-14">
        <h2 className="text-3xl sm:text-4xl font-semibold mb-4 tracking-tight text-apple-50">
          How tax-season filing works
        </h2>
        <p className="text-apple-300 text-lg font-light max-w-2xl mx-auto">
          Four steps from a downloads folder of unidentified PDFs to clean per-client tax-year
          folders.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {STEPS.map((step, i) => {
          const Icon = step.icon;
          return (
            <div key={i} className="relative bg-apple-800/40 backdrop-blur-sm rounded-2xl border border-apple-700/50 p-6 flex flex-col">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 rounded-full bg-sortio-primary/15 border border-sortio-primary/30 flex items-center justify-center mr-3">
                  <Icon className="text-sortio-primary" size={18} />
                </div>
                <span className="text-xs font-medium uppercase tracking-wider text-apple-400">Step {i + 1}</span>
              </div>
              <h3 className="text-lg font-medium text-apple-50 mb-2">{step.title}</h3>
              <p className="text-sm text-apple-200 leading-relaxed">{step.body}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Workflow;
